import React from "react";
import styled, { css } from "styled-components";

import BeemaLogo from "../../assets/logo/logo_croped.png";
import { theme } from "../../theme";

const LogoContainer = styled.div`
  display: flex;
  flex-direction: ${({ inline }) => (inline ? "row" : "column")};
  align-items: center;
`;

const LogoImg = styled.img`
  width: 20em;
  height: 20em;

  ${({ inline }) =>
    inline &&
    css`
      width: 94px;
      height: 99px;
      margin-right: 6px;
      margin-top: 65px;
    `};

  ${({ small }) =>
    small &&
    css`
      width: 6em;
      height: 7em;
    `};
`;

const LogoText = styled.div`
  margin-top: ${({ inline }) => (inline ? 0 : "6px")};
  font-size: ${({ inline, small }) =>
    inline ? "39px" : small ? "23px" : "40px"};
  color: ${({ inline }) => (inline ? "#fff" : theme.primary)};
  font-weight: 900;
        margin-top: 55px;

`;

export function Logo(props) {
  const { inline, small } = props;

  return (
    <LogoContainer inline={inline} small={small}>
      <LogoImg src={BeemaLogo} inline={inline} small={small} />
      <LogoText inline={inline} small={small}>
        {/* Merka Labs Corp */}
      </LogoText>
    </LogoContainer>
  );
}
